import React from 'react';
import { Typography, Button, Modal } from '@douyinfe/semi-ui';
import { IconClose } from '@douyinfe/semi-icons';

class ModalDetails extends React.Component {
    constructor(props) {
        super(props);
    }

    render () {
        const { open, project_name, details, onClose } = this.props;

        const handleCloseClick = () => {
            onClose();
        };

        return (
            <Modal
                visible={open}
                onCancel={handleCloseClick}
                maskClosable={false}
                className="custom-modal"
                size="medium"
                header={<div className="custom-modal-header">{project_name}</div>}
                footer={
                    <div className="custom-modal-footer">
                        <Button icon={<IconClose />} className="button-custom" onClick={handleCloseClick}>Close</Button>
                    </div>
                }
            >
                <div className="custom-modal-body">
                    <Typography.Paragraph>
                        {details}
                    </Typography.Paragraph>
                </div>
            </Modal>
        );
    }
}

export default ModalDetails;